module.exports = "<a class=\"btn btn-default btn-lg\" target=\"_blank\" href=\"{{previewLink}}\">\n    <i class=\"fi fi-view\"></i>{{ text }}\n</a>"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/preview-btn/preview-btn.html
// module id = ./web/modern/components/buttons/preview-btn/preview-btn.html
// module chunks = 0